import api from "shared/api";
import { BaseApiService } from "shared/api";
import { withToast } from "shared/utils";

class UserService extends BaseApiService {
  async updateProfile(payload, toastOptions = {}) {
    return await withToast(
      () =>
        api
          .patch(this.ENDPOINTS.user.update, payload)
          .then((response) => response?.data?.data),
      {
        onSuccess: "Profile was updated",
        ...toastOptions,
      }
    );
  }
}

export default new UserService();
